import React from 'react'
import { Outlet } from 'react-router-dom'

const CreatorAvatarLayout = () => {
  return (
    <div className="background-gradient">
      <main className="min-h-screen">
        <Outlet />
      </main>
    </div>
  )
}

export default CreatorAvatarLayout
